import {
  apiRoutes,
  type DefaultQueryError,
  httpClient,
  type ItemTrend,
  type ItemTrends,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

export const getItemTrendListFn = async () => {
  const response = await httpClient.get<ItemTrends>(
    apiRoutes.insurance.item.trends,
    {}
  );
  return response.data;
};

export const useGetItemTrend = (
  opts?: Omit<UseQueryOptions<ItemTrend[], DefaultQueryError>, 'queryKey'>
) =>
  useQuery<ItemTrend[], DefaultQueryError>({
    queryKey: [apiRoutes.insurance.item.trends],
    queryFn: getItemTrendListFn,
    ...opts,
  });
